import { ChangeDetectionStrategy, Component, input } from '@angular/core';

@Component({
  selector: 'svg[mib-details-icon]',
  template: `
    <svg:path
      d="M4.33333 0.666016C3.04467 0.666016 2 1.71068 2 2.99935V12.9993C2 14.288 3.04467 15.3327 4.33333 15.3327H11.6667C12.9553 15.3327 14 14.288 14 12.9993V2.99935C14 1.71068 12.9553 0.666016 11.6667 0.666016H4.33333ZM3.33333 2.99935C3.33333 2.44706 3.78105 1.99935 4.33333 1.99935H11.6667C12.219 1.99935 12.6667 2.44706 12.6667 2.99935V12.9993C12.6667 13.5516 12.219 13.9993 11.6667 13.9993H4.33333C3.78105 13.9993 3.33333 13.5516 3.33333 12.9993V2.99935ZM5.33333 4.66602C4.96514 4.66602 4.66667 4.96449 4.66667 5.33268C4.66667 5.70087 4.96514 5.99935 5.33333 5.99935H10.6667C11.0349 5.99935 11.3333 5.70087 11.3333 5.33268C11.3333 4.96449 11.0349 4.66602 10.6667 4.66602H5.33333ZM4.66667 7.99935C4.66667 7.63116 4.96514 7.33268 5.33333 7.33268H10.6667C11.0349 7.33268 11.3333 7.63116 11.3333 7.99935C11.3333 8.36754 11.0349 8.66602 10.6667 8.66602H5.33333C4.96514 8.66602 4.66667 8.36754 4.66667 7.99935ZM5.33333 9.99935C4.96514 9.99935 4.66667 10.2978 4.66667 10.666C4.66667 11.0342 4.96514 11.3327 5.33333 11.3327H8.66667C9.03486 11.3327 9.33333 11.0342 9.33333 10.666C9.33333 10.2978 9.03486 9.99935 8.66667 9.99935H5.33333Z" />
  `,
  host: {
    '[attr.viewBox]': 'viewBox()',
    class: 'mib-icon-default-size fill-current transition-colors',
    '[class]': 'extraClass()',
  },
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DetailsIcon {
  readonly viewBox = input<string>('0 0 16 16');
  readonly extraClass = input<string>('');
}
